
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookinginfo",
      function () {
        return require("private-next-pages/bookinginfo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookinginfo"])
      });
    }
  